module.exports = __webpack_public_path__ + "img/img12.6e203735.png";